import axios from 'axios';
const baseURL = 'https://opticounter.pl/eyecounter-backend'; ; //HTTPS PROD
//const baseURL = 'http://localhost:8096'; //HTTP Dev

//Change vue.config.js publicPath
axios.defaults.headers.get['Accepts'] = 'application/json';
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
axios.defaults.headers.common['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';

export default axios.create({
  baseURL,
});
